import {useSortable} from '@dnd-kit/sortable';
import {CSS} from '@dnd-kit/utilities';
import type {CSSProperties} from 'react';
import type {EntryManagementSummaryType} from '../../../../../core/repositories/mypageEntryManagementsRepository';
import {ProgressCard} from '../Presenter/Progress/ProgressCard';

type Props = {
  /** ドラッグ可能なアイテムの一意なID (形式: "columnId-entryId") */
  id: string;
  /** 表示するエントリーデータ */
  entry: EntryManagementSummaryType;
  /** 選択状態かどうか */
  isSelected?: boolean;
  /** falseを返すと詳細への遷移を中断する */
  canOpenDetail?: () => boolean;
};

/**
 * ドラッグ&ドロップ可能なProgressCardコンポーネント
 * カンバンボード内でのエントリーの移動を可能にする
 */
export const DraggableProgressCard: React.FC<Props> = ({
  id,
  entry,
  isSelected,
  canOpenDetail,
}) => {
  const {attributes, listeners, setNodeRef, transform, transition, isDragging} =
    useSortable({id});

  const style: CSSProperties = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
  };

  return (
    <div
      ref={setNodeRef}
      style={style}
      {...attributes}
      {...listeners}
      className="cursor-grab active:cursor-grabbing"
    >
      <ProgressCard
        entry={entry}
        isSelected={isSelected}
        canOpenDetail={canOpenDetail}
      />
    </div>
  );
};
